export default __webpack_public_path__ + "static/media/kwpwroclaw.af05c2d5.png";